var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{attrs:{"vs-type":"flex","vs-align":"center","vs-justify":"flex-start"}},[_c('feather-icon',{attrs:{"icon":_vm.icon,"svgClasses":"h-5 w-5"}}),_c('span',{staticClass:"ml-3"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }